export class Grid {
  SearchVisible = true;
  title = '';
  SortDisabled = false;
  EditVisible = false;
  ManageVisible = false;
  EditAccess: any = [];
  DeleteAccess: any = [];
  ImportVisible = false;
  ExportVisible = true;
  EditHighlight = true;
  DeleteVisible = false;
  editEachRow = false;
  refreshGrid = false;
  AddLinesVisible = false;
  SplitTrxVisible = false;
  AddSettingsVisible = false;
  usageCostVisible = false;
  ViewVisible = true;
  subscribeVisible = false;
  CloseVisible = false;
  SendVisible = false;
  ShowCheckbox = false;
  ShowToggle = false;
  launchVisible = false;
  makeVisible = false;
  toggleChecked = false;
  CheckboxChecked = false;
  TaskInfoVisible = false;
  ItemsPerPage = 10;
  PaginationVisible = true;
  PaginationId: string = ''; // Assign an initial value to PaginationId
  totalRecods: number = 0; // Assign an initial value to totalRecods
  chatVisible = false;
  addTocart = false;
  shortList = false;
  selected = false;
  addTofavourite = false;
  rating = false;
  goToCrm = false;
  addToCrm = false;
  goToEC = false;
  sendInvoiceIcon: boolean = false;
  WalletVisible: any;
}

